import React from 'react';
import { Modal } from 'antd';
import styles from './styles.module.css';
import * as translations from './strings';
import { getLangKey } from '../../../../models/Language';
import { X as Close } from 'lucide-react';
import { format, parseISO } from 'date-fns';

const strings = translations[getLangKey()];

type Props = {
  isModalOpen: boolean;
  error?: {
    created_at?: string;
    message: string;
  };
  createError: string;
  setIsModalOpen: (open: boolean) => void;
};
export const WhyModal: React.FC<Props> = ({
  isModalOpen,
  error,
  createError,
  setIsModalOpen
}) => {
  const handleClose = () => {
    setIsModalOpen(false);
  };

  const container = document.getElementById('kanbanBoard');
  if (!container) throw new Error('No container found to mount modal to');

  return (
    <Modal
      open={isModalOpen}
      getContainer={container}
      closable={false}
      onCancel={handleClose}
      footer={null}
      className={styles.whyModal}
    >
      <h2>{strings.errorTitle}</h2>
      <div className={styles.closeContainer} onClick={handleClose}>
        <Close className={styles.closeIcon} />
      </div>
      <div className={styles.contentContainer}>
        <dl className={styles.errorDetails}>
          {error?.created_at && (
            <div className={styles.errorDetailRow}>
              <dt className={styles.errorDetailLabel}>Timestamp</dt>
              <dd className={styles.errorDetailValue}>
                <time dateTime={error.created_at}>
                  {format(parseISO(error.created_at), 'MMM d, yyyy h:mm a')}
                </time>
              </dd>
            </div>
          )}
          <div className={styles.errorDetailRow}>
            <dt className={styles.errorDetailLabel}>Message</dt>
            <dd className={styles.errorDetailValue}>
              {error?.message || createError}
            </dd>
          </div>
        </dl>
      </div>
    </Modal>
  );
};
